export default "__VITE_ASSET___KVvPwDj__"